import { AlertCircle } from 'lucide-react'
import type { UserItem } from '@/components/Configuracao/usersTabConstants'
import { passwordSetupNeedsResend } from '@/components/Configuracao/userPasswordSetupUi'

export function UsersTabPendingBanner({ users }: { users: UserItem[] }) {
  const pending = users.filter((u) => passwordSetupNeedsResend(u.passwordSetupStatus))
  if (pending.length === 0) return null

  return (
    <div className='mx-4 mt-3 flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2.5 text-[13px] text-amber-100'>
      <AlertCircle size={16} className='mt-0.5 shrink-0 text-amber-400' aria-hidden />
      <p>
        <strong className='font-semibold text-amber-50'>
          {pending.length} usuário{pending.length > 1 ? 's' : ''} sem senha definida
        </strong>
        {' — '}
        use <strong className='font-semibold'>Reenviar e-mail</strong> para enviar um novo link de cadastro
        (válido por 72h).
      </p>
    </div>
  )
}
